import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer
          className="footer"
          style={{
            background: "#212529",
            color: "rgba(255, 255, 255, 0.95)",
            padding: "2rem 0",
          }}
        >
          <div className="px-5">
            <Row className="mb-4 justify-content-between">
              <Col md="4" className="text-left">
                <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
                  <img
                    src={require("src/assets/img/site-logo.png")}
                    style={{ height: 70, background: "white" }}
                  />
                </h4>
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.75)",
                    fontSize: "15px",
                  }}
                >
                  A comprehensive, integrated platform bringing together Faculty
                  members, Researchers, Research publications, Publishers and
                  Journals worldwide.
                </p>
              </Col>

              <Col md="4" className="text-md-end">
                <Nav className="nav-footer flex-column">
                  <NavItem>
                    <NavLink
                      href="/terms-condition"
                      style={{ color: "rgba(255, 255, 255, 0.75)" }}
                    >
                      Terms & Conditions
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="/about-us"
                      style={{ color: "rgba(255, 255, 255, 0.75)" }}
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="/contact"
                      style={{ color: "rgba(255, 255, 255, 0.75)" }}
                    >
                      Contact Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="/privacy-policy"
                      style={{ color: "rgba(255, 255, 255, 0.75)" }}
                    >
                      Privacy Policy
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </div>
          <hr style={{ borderColor: "rgba(255, 255, 255, 0.2)" }} />
          <div className="px-5">
            <Row className="align-items-center justify-content-between">
              <Col md="6">
                <div className="social-icons">
                  <Button
                    className="btn-icon-only rounded-circle"
                    color="twitter"
                    href="#"
                    id="tooltip-twitter"
                  >
                    <i className="fa fa-twitter" />
                  </Button>
                  <UncontrolledTooltip
                    delay={0}
                    target="tooltip-twitter"
                    timeout
                  >
                    Follow us on Twitter
                  </UncontrolledTooltip>
                  <Button
                    className="btn-icon-only rounded-circle ml-1"
                    color="facebook"
                    href="#"
                    id="tooltip-facebook"
                  >
                    <i className="fa fa-facebook-square" />
                  </Button>
                  <UncontrolledTooltip delay={0} target="tooltip-facebook">
                    Like us on Facebook
                  </UncontrolledTooltip>
                  <Button
                    className="btn-icon-only rounded-circle ml-1"
                    href="#"
                    id="tooltip-linkedin"
                    style={{
                      backgroundColor: "#0077b5",
                      border: "none",
                    }}
                  >
                    <i className="fa fa-linkedin" style={{ color: "#fff" }} />
                  </Button>
                  <UncontrolledTooltip delay={0} target="tooltip-linkedin">
                    Follow us on LinkedIn
                  </UncontrolledTooltip>

                  <Button
                    className="btn-icon-only rounded-circle"
                    href="#"
                    id="tooltip-instagram"
                    style={{
                      background:
                        "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF)",
                      border: "none",
                    }}
                  >
                    <i className="fa fa-instagram" style={{ color: "#fff" }} />
                  </Button>
                  <UncontrolledTooltip delay={0} target="tooltip-instagram">
                    Follow us on Instagram
                  </UncontrolledTooltip>
                </div>
              </Col>
              <Col md="6" className="text-md-right">
                <p
                  className="copyright"
                  style={{
                    color: "rgba(255, 255, 255, 0.75)",
                    marginBottom: "0",
                  }}
                >
                  © {new Date().getFullYear()} M/S ANUSHA PUBLICATION. All
                  Rights Reserved.
                </p>
              </Col>
            </Row>
          </div>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
